export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3003';
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';
export const ENABLE_AI_DESIGN_STUDIO = process.env.REACT_APP_ENABLE_AI_DESIGN_STUDIO === 'true';
// Per-shop platform-subdomain sending (noreply@{subdomain}.craftflow.store) is DISABLED.
// It wrote per-shop DNS under {subdomain}.craftflow.store, which disabled Vercel's
// *.craftflow.store storefront wildcard for those shops (prod incident 2026-07-10). The
// admin card stays hidden regardless of REACT_APP_ENABLE_SUBDOMAIN_SENDER until the feature
// is redesigned — see server/src/services/subdomain_sender_reconciler.py.
export const ENABLE_SUBDOMAIN_SENDER = false;
// Async print-job flow (202 + poll) instead of the blocking
// NDJSON-stream render — the heavy render runs off the web request path
// so it can't OOM/block the Gunicorn worker.
//
// Phase 4 (deprecate, don't delete): async is now the DEFAULT. Set
// REACT_APP_PRINTFILE_ASYNC=false to fall back to the legacy synchronous
// path — kept as a rollback lever until the async path has soaked.
export const PRINTFILE_ASYNC = process.env.REACT_APP_PRINTFILE_ASYNC !== 'false';
